import { render, staticRenderFns } from "./MarksUploadForm.vue?vue&type=template&id=d58826f6&scoped=true&"
import script from "./MarksUploadForm.vue?vue&type=script&lang=js&"
export * from "./MarksUploadForm.vue?vue&type=script&lang=js&"
import style0 from "./MarksUploadForm.vue?vue&type=style&index=0&id=d58826f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58826f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
